import { i18n, i18nSymbol } from '@/i18n';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { WorkspaceStartup, WorkspaceStartupSymbol } from '@/startup';
import { ravenModule } from '@cores/modules/raven-module/raven-module';
import { RouterService } from '@cores/services/vue-router-service';
import { router } from '@/routers';
import { DateFormatter } from '@/infrastructure/utils/date-formatter.interface';
import formatDate from '@/infrastructure/utils/formatDate';
import { Logger } from '@patsnap/tahiti-core/common/logger';
import { Message } from '@patsnap/tahiti-core/common/message';
import { Toast } from 'patsnap-biz';
import { DialogManager } from '@patsnap/tahiti-core/services/dialog-manager';
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { LocationService } from '@patsnap/tahiti-core/services/location-service';
import { OpenService, OpenServiceImpl } from '@patsnap/tahiti-core/services/open-service';
import { CommandContribution, CommandRegistry, CommandService } from '@patsnap/tahiti-core/common/command';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { ErrorHandler, ErrorHandlerImpl } from '@patsnap/tahiti-core/common/error-handler';
import { I18nService } from '@/services/i18n-service';
import { RouteGuard } from '@patsnap/tahiti-core/services/abstract-dialog-service';
import { TimezoneServiceImpl } from '@/services/impls/timezone-service';
import { TimezoneService } from '@/services/timezone-service';
import { SSEPsHttpImpl, FactoryPsHttpSSE, PsHttpSSE } from '@patsnap-utils/sse';
export const base = new ContainerModule(bind => {
    bind(i18nSymbol).toConstantValue(i18n);
    bind(I18nService).toConstantValue(i18n);
    bind(RouterService).toConstantValue(router);
    bind(WorkspaceStartupSymbol).to(WorkspaceStartup);
    ravenModule(bind)('Workspace');
    bind(DateFormatter).toConstantValue({
        format: formatDate,
    });
    bind(OpenService).to(OpenServiceImpl);
    bind(Logger).toConstantValue(console);
    bind(Message).toConstantValue(Toast);
    bind(DialogManager).toConstantValue(ptDialogAutoMounterManager);
    bind(RouteGuard).toConstantValue(router);
    bind(LocationService).toConstantValue(window.location);
    bind(CommandRegistry).toSelf();
    bind(CommandService).toDynamicValue(context => context.container.get(CommandRegistry));
    bind(PsHttpSSE).to(SSEPsHttpImpl).inRequestScope();
    bind(FactoryPsHttpSSE).toDynamicValue(context => () => context.container.get(PsHttpSSE));
    bindContributionProvider(bind, CommandContribution);
    bind(ErrorHandler).to(ErrorHandlerImpl);
    bind(TimezoneService).to(TimezoneServiceImpl);
});
